import { Backdrop } from '@mui/material';
import styled from 'styled-components';

export interface IStyleWrapper {
  textColor?: string;
}

interface IStyledLoadingWithBackdrop {
  stylewrapper?: IStyleWrapper;
}

export const StyledLoadingWithBackdrop = styled(Backdrop)<IStyledLoadingWithBackdrop>(
  ({ theme, stylewrapper }) => `
    z-index: 100000 !important;
    flex-direction: column;
    color: ${stylewrapper?.textColor || theme.uptimeColors.grayScales.white};

    .circular {
      color: ${theme.uptimeColors.grayScales.white};
    }

    .wrapper {
      position: relative;
      display: inline-flex;

      .percentage {
        position: absolute;
        inset: 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    
    .message {
      font-family: ${theme.uptimeFonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`};
      font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
    }
  `
);

export const StyledLoadingProgress = styled.div`
  ${({ theme }) => `
    display: flex;
    align-items: center;
    justify-content: center;
    .MuiCircularProgress-svg {
      color: ${theme.uptimeColors.generalColors.icon.enabled};
    }
  
  `}
`;
